<template>
  <div>
    <van-nav-bar left-arrow fixed title="认购详情" @click-left="goableBack()" :z-index="10"></van-nav-bar>

    <div class="main">
      <!-- ---------------------------------------------------- -->
      <div class="main-box fy">
        <!-- header -->
        <div class="header">
          <div class="title" @click="onDetial(invest)">
            <!-- <router-link
              :to="{ path: '/detail', query: { productId: invest.productId } }"
              >{{ invest.productName }}</router-link
            > -->
            {{ invest.productName }}
            <van-icon v-if="invest.status != 3" color="#c6c6c6" name="arrow" />
          </div>
          <div class="center">
            <div class="t">{{ numFormat(invest.amount) }}</div>
            <div class="d">认购金额(元)</div>
          </div>
          <div class="down">
            <div class="down-left">
              <span>预期年化收益率：</span>
              <span>{{ investRate }}</span>
            </div>
            <div class="down-right">
              <span>投资期限：</span>
              <span>{{ invest.investDuration }}天</span>
            </div>
          </div>
          <van-tag size="large" mark :color="tags[status].bg" :text-color="tags[status].color">{{ tags[status].text }}</van-tag>
        </div>

        <div class="income">
          <div class="first">
            <span class="left">预期收益(元)</span>
            <span class="right money">{{ invest.returnAmount / 100 }} 元</span>
          </div>
          <div class="first">
            <span class="left">收益起算日</span>
            <span class="right">{{
              dateFormat(invest.beginTime, "YYYY-MM-DD")
            }}</span>
          </div>
          <div class="first">
            <span class="left">收益到期日</span>
            <span class="right">{{
              dateFormat(invest.endTime, "YYYY-MM-DD")
            }}</span>
          </div>
          <div class="first">
            <span class="left">认购时间</span>
            <span class="right">{{
              dateFormat(invest.createTime, "YYYY-MM-DD")
            }}</span>
          </div>
          <div class="first" v-if="invest.isShow == true">
            <span class="left">操作</span>
            <router-link class="right" style="color: blue" :to="{ name: 'agreement-trade', query: { id: invest.id } }">查看协议</router-link>
          </div>
          <!--<div class="first b">
            <span class="left">兑付方式</span>
            <span class="right">按季付息，到期回本</span>
          </div>-->
        </div>

        <!-- 回款计划 -->
        <div class="plan fy">
          <van-collapse v-model="activeNames">
            <van-collapse-item name="1" v-if="invest.returnPlans && invest.returnPlans.length > 0">
              <template #title>
                <div class="first">回款计划</div>
              </template>
              <table class="table">
                <tr>
                  <th>期数</th>
                  <th>预期收益</th>
                  <th>收益结算日</th>
                  <th>状态</th>
                </tr>
                <tr v-for="(n, i) of invest.returnPlans" :key="i">
                  <td>{{ n.step }}</td>
                  <td>{{ numFormat(n.amount) }}</td>
                  <td>{{ dateFormat(n.payTime, "YYYY-MM-DD") }}</td>
                  <td>{{ statusText[n.status] }}</td>
                </tr>
              </table>
            </van-collapse-item>
            <!-- <van-cell title="回款账户" is-link value="内容" />-->
          </van-collapse>
        </div>
      </div>
      <!-- 认购记录 -->
      <!-- <div class="subscribe">
        <div class="box">
          <div class="title">认购记录</div>
          <table>
            <thead>
              <tr>
                <th>认购金额</th>
                <th>认购时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(n, i) of invest.buyRecords" :key="`buy-${i}`">
                <td>{{ n.amount / 100 }}</td>
                <td>{{ dateFormat(n.payTime, "YYYY-MM-DD") }}</td>
                <td>
                  <router-link
                    :to="{ name: 'agreement-trade', query: { id: n.investId } }"
                    >{{ invest.isShow == true ? "查看协议" : "" }}</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="false" class="tab">
            <div class="tab-item">
              <span>认购记录</span>
              <span>认购时间</span>
              <span>操作</span>
            </div>

            <div class="tab-list">
              <span>10000</span>
              <span>2020/7/24</span>
              <a href="#">查看协议</a>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- 再次认购 -->
    <div class="aginstshop">
      <van-cell v-if="invest.status === 1 && canRevocation" style="margin-bottom: 20px" is-link @click="showPopup">撤销认购</van-cell>
      <van-button class="buy" v-if="canbuy" plain size="large" @click="onReBuyProduct(invest)">再次认购</van-button>
      <van-button class="sell-out" v-else plain size="large">{{
        canbuyText
      }}</van-button>
    </div>

    <!-- popup -->
    <van-popup duration="0.5" round v-model="show">
      <div class="popup-content">
        <div class="title">
          募集期内，如果您后悔认购，可撤销认购。撤销成功后，已认购资金将退回到您的余额账户。确定撤销吗？
        </div>
        <div class="select">
          <van-button class="sp1" square @click="show = false">取消</van-button>
          <van-button class="sp2" square :loading="loading" @click="onRevoke">确认</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 是否进行风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Icon, Cell, Tag, Collapse, CollapseItem, Button, Popup } from "vant"
import { investDetail, cancelInvest, cancelInvestChannel } from "@/api/pay.js"
import { canbuy } from "@/api/product"
import { mapGetters } from "vuex"
import { productIsPurchase } from "../../api/product"
export default {
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Popup.name]: Popup
  },
  props: {
    id: {
      required: true,
      type: String
    },
    status: {
      required: true,
      type: [Number, String]
    }
  },
  computed: {
    ...mapGetters(["userInfo", "token", "deviceToken", "channel"]),
    investRate() {
      if (
        this.invest.max &&
        this.invest.min &&
        this.invest.max > this.invest.min
      ) {
        return this.invest.min + "%" + "~" + this.invest.max + "%"
      } else {
        return this.invest.rate + "%"
      }
    }
  },
  data: () => ({
    canRevocation: false,
    show: false,
    loading: false,
    assessShow: false,
    resetAssessShow: false,
    activeNames: ["1"],
    invest: {},
    tags: {
      1: { bg: "#5ac909", text: "申请中", color: "#fff" },
      2: { bg: "#fcd32b", text: "持有中", color: "#61531e" },
      3: { bg: "#f62f1a", text: "已结清", color: "#fff" }
    },
    canbuy: {},
    canbuyText: "已售罄",
    statusText: {
      0: "待收款",
      1: "已收款",
      3: "待收款",
      4: "待收款",
      6: '已协商兑付',
      7: '已协商展期'
    }
  }),
  beforeMount() {
    //检测测评
    //forceAssess 是否强制评测
    //assessNum 已评测次数
    console.log("beforeMount")
    this.resetAssessShow =
      this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
    if (this.userInfo.userLevel < 1) {
      this.assessShow = this.resetAssessShow == true ? false : true
    }
  },
  mounted() {
    investDetail(this.$route.params.id, this.$route.params.status)
      .then((data) => {
        this.invest = data
        this.setData()
      })
      .catch((e) => {
        console.info(e)
      })
  },
  methods: {
    setData() {
      this.getCanBy()
      cancelInvestChannel(this.invest.chanlCode)
        .then((data) => {
          this.canRevocation = data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getCanBy() {
      canbuy(this.invest.productId)
        .then((data) => {
          this.canbuy = data.canBuy
          // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
          if (data.code == 3006) {
            this.assessShow = this.resetAssessShow == true ? false : true
          }
          if (data.code != 0) {
            this.canbuyText = data.msg || "已售罄"
          }
        })
        .catch((e) => {
          console.info(e)
        })
    },
    showPopup() {
      this.show = true
    },
    onRevoke() {
      this.loading = true
      this.show = false
      cancelInvest(this.invest.id)
        .then((data) => {
          this.$toast({
            message: "撤销成功，认购资金预计1分钟内退回到余额",
            duration: "3000",
            onClose: () => {
              this.goableBack()
            }
          })
        })
        .catch((e) => {
          this.loading = false
          this.$toast(e.msg || e.message)
        })
    },
    goAssess() {
      this.$router.push({ name: "questions" })
    },
    onReBuyProduct(item) {
      if (item.productType == 4) {
        this.onExperienceBuy()
      } else {
        this.$router.push({
          path: "/buying",
          query: { productId: item.productId }
        })
      }
    },
    onDetial(item) {
      if (item.status != 3) {
        if (item.productType == 4) {
          this.onExperienceBuy()
        } else {
          this.$router.push({
            path: "/detail",
            query: { productId: item.productId }
          })
        }
      }
    },
    onExperienceBuy() {
      productIsPurchase()
        .then((data) => {
          if (data) {
            this.$router.push({ path: "/invest" })
          } else {
            this._showTipsInfo(
              "温馨提示",
              "您已认购过该资产，可至“我的理财”中查看认购的体验金资产详情",
              "",
              "好的",
              () => { },
              () => { }
            )
          }
        })
        .catch((e) => { })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  margin: 0 13px;
  color: #666;

  // 认购记录
  .subscribe {
    margin-top: 10px;
    margin-bottom: 100px;
    background-color: #fff;
    border-radius: 6px;

    .box {
      padding: 10px 16px 0 16px;
      .title {
        font-size: 15px;
        font-weight: 700;
        padding-bottom: 10px;
      }
      // .tab {
      //   .tab-list {
      //     a {
      //       color: blue;
      //     }
      //   }
      // }
    }
    table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;

      td,
      th {
        text-align: center;
        line-height: 45px;
        border-color: #ebeaea;
        border-style: dashed;
        border-width: 1px 0 1px 0;
      }
      th {
        font-weight: 400;
        border-style: solid;
      }
      tr td {
        width: calc((100vw - 32px) / 3);
      }
      tr:last-child td {
        border-bottom: none;
      }
    }
    a {
      color: blue;
    }
  }

  // --------------------------------
  .main-box {
    margin-top: 55px;
    margin-bottom: 120px;
    padding: 13px;
    border-radius: 6px;
    background-color: #fff;

    // 盒子1
    .header {
      border-bottom: 1px dashed #ebeaea;
      // border: 1px solid #000000;
      position: relative;
      // 标题
      .title {
        font-size: 16px;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      // 认购金额
      .center {
        text-align: center;

        .t {
          margin-top: 15px;
          font-size: 30px;
          font-weight: 600;
          color: #fc6524;
        }
        .d {
          margin-top: 5px;
          font-size: 15px;
        }
      }
      // 期限/收益率
      .down {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 22px 0;
        span {
          font-size: 13px;
          color: #999999;
        }
      }
      // 持有标签
      .van-tag {
        position: absolute;
        top: 50px;
        left: -14px;
      }
    }
    // 盒子2
    .income {
      //border-bottom: 1px dashed #ebeaea;
      .first {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 45px;
        .left {
          font-size: 14px;
          color: #666666;
        }
        .right {
          color: #333333;
        }
        .money {
          color: #fc6524;
        }
      }
      .b {
        padding-bottom: 15px;
      }
    }
    // 盒子3 plan
    .plan {
      .van-collapse-item {
        padding: 10px 0;

        .first {
          font-size: 13px;
          color: #666666;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
        .table {
          width: 100%;
          margin-top: 16px;

          color: #666666;
          th,
          td {
            padding: 0;
            border: 1px solid #f1f1f1;
            text-align: center;
            vertical-align: middle;
            line-height: 1.1rem;
          }
          th {
            padding: 0 11px;
          }
        }
      }
      .van-cell {
        padding: 13px 0;
      }
      .van-hairline--top-bottom:after {
        border: none;
      }
      .van-cell--clickable::after {
        border: none;
      }
      /deep/ .van-cell__title {
        font-size: 13px;
        color: #666666;
        font-weight: 700;
      }
      /deep/ .van-cell__value {
        font-size: 13px;
        color: #333333;
      }
    }
  }
}

//3再次认购
.aginstshop {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  // border: 1px solid #000000;
  .text {
    font-size: 13px;
    letter-spacing: 1px;
    text-align: center;
    .ce {
      color: #fc6524;
    }
  }
  .van-button {
    height: 50px;
    font-size: 15px;
    letter-spacing: 1px;
  }
  .buy {
    background-color: #d6ae73;
    color: #ffffff;
  }
  .sell-out {
    background-color: #d1d1d3;
    color: #ffffff;
  }
}

// 撤销认购 popup
.van-popup {
  border-radius: 5px;

  .popup-content {
    width: 275px;
    height: 160px;
    position: relative;

    .title {
      width: 210px;
      margin: auto;
      padding-top: 20px;
      font-size: 14px;
      color: #666;
    }

    .select {
      display: flex;
      height: 40px;
      position: absolute;
      bottom: 0;
      left: 0;

      span {
        line-height: 40px;
        text-align: center;
      }
      .sp1 {
        width: 137px;
        color: #666;
        background-color: #dcdcdc;

        height: 100%;
        border: none;
      }
      .sp2 {
        width: 138px;
        color: #fff;
        background-color: #fc6524;

        height: 100%;
        border: none;
      }
    }
  }
}

.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
</style>
